import { Component, Input } from '@angular/core';
import { PricingBreakdown, PricingBreakdownLine, PricingBreakdownLineType } from 'app/models';

@Component({
    selector: 'booking-receipt',
    templateUrl: './booking-receipt.component.html',
    styleUrls: ['./booking-receipt.component.scss']
})
export class BookingReceiptComponent {
    @Input() customer?: PricingBreakdown;
    @Input() driver?: PricingBreakdown;

    constructor() {}

    public isHeader(line: PricingBreakdownLine): boolean {
        return line.LineType === PricingBreakdownLineType.Header;
    }

    public isTotal(line: PricingBreakdownLine): boolean {
        return line.LineType === PricingBreakdownLineType.Total;
    }

    public isIndented(line: PricingBreakdownLine): boolean {
        return line.IsIndented === true;
    }

    public formatAmount(line: PricingBreakdownLine): string {
        if (line.LineType === PricingBreakdownLineType.Text) {
            return line.Text || '-';
        }

        const amount = line.Amount ?? 0;
        const isNegative = line.LineType === PricingBreakdownLineType.Deduction || amount < 0;
        return `${isNegative ? '- ' : ''}₱ ${Math.abs(amount).toFixed(2)}`;
    }
}
